<template>
  <b-container>
    <Breadcrumbs crumbString="Products,Graphic Panels,Digital Composites"></Breadcrumbs>
    <b-row class="image-slider-container">
      <b-col class="col-12 col-md-4 col-lg-4">
        <h2>{{ title }}</h2>
        <div>Digital-graphics, printed to various substrates</div><br>
        <div>Composite signs are typically less costly and used for more temporary situations. The graphics can be
          printed on the surface of a substrate material with a protective layer adhered to the surface. Die cut
          vinyl graphics are also used.</div>
      </b-col>
      <b-col class="col-12 col-md-8 col-lg-8">
        <ImageSlider :images="images" class="image-slider"></ImageSlider>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import Breadcrumbs from '@/components/Breadcrumbs.vue'
  import ImageSlider from '@/components/ImageSlider.vue'

  export default {
    components: {
      Breadcrumbs,
      ImageSlider
    },
    props: {
      images: {
        default: () => [
          require('@/assets/images/pages/composite/digital-composite-interpretive-sign01.jpg'),
          require('@/assets/images/pages/composite/digital-composite-interpretive-sign02.jpg'),
          require('@/assets/images/pages/composite/digital-composite-interpretive-sign03.jpg'),
          require('@/assets/images/pages/composite/digital-composite-interpretive-sign04.jpg'),
          require('@/assets/images/pages/composite/digital-composite-interpretive-sign05.jpg'),
          require('@/assets/images/pages/composite/digital-composite-interpretive-sign06.jpg'),
          require('@/assets/images/pages/composite/digital-composite-interpretive-sign07.jpg'),
          require('@/assets/images/pages/composite/digital-composite-interpretive-sign08.jpg'),
          require('@/assets/images/pages/composite/digital-composite-interpretive-sign09.jpg'),
          require('@/assets/images/pages/composite/digital-composite-interpretive-sign10.jpg')
        ],
        type: Array
      }
    },

    data () {
      return {
        title: 'Digital Composites'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/products/Composite.vue